import React from 'react'
import StyledXlText from '../../common/components/styledXlText/StyledXlText'
import StyledMdText from '../../common/components/styledMdText/StyledMdText'

const NotFoundPage = () => {
  return (
    <div className='flex justify-center w-full py-40'>
      <div className='w-[90%] flex flex-col gap-5 items-center'>
        <div>
          <img width={500} height={300} src='/assets/images/404.webp' alt='404' />
        </div>
        <div className='flex flex-col gap-3 text-center'>
          <div>
            <StyledXlText fontColor="text-gradient">404 :)</StyledXlText>
          </div>
          <StyledMdText fontColor="text-white">Page Not Found!</StyledMdText>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
